angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/engineers/viewEngineersOld.html',
    '<section id="viewEngineers" class="content dashboard public">\n' +
    '	<div class="container">\n' +
    '		<div class="row">\n' +
    '			<div class="col-sm-3">\n' +
    '				<h2>Engineers</h2>\n' +
    '			</div>\n' +
    '			<div class="col-sm-9 filters">\n' +
    '				<form>\n' +
    '					<ul class="list-inline">\n' +
    '						<li class="form-group hidden-xs">\n' +
    '							<h5>Filter</h5>\n' +
    '						</li>\n' +
    '						<li class="form-group filter-a">\n' +
    '							<label class="select input-type">\n' +
    '								<select ng-change="onLicenseChange()" ng-options="l.Label disable when !l.Available for l in engineerLicenses" ng-model="filters.license"\n' +
    '								 class="form-control input-lg">\n' +
    '									<option value="">Licenses (All)</option>\n' +
    '								</select>\n' +
    '							</label>\n' +
    '						</li>\n' +
    '						<li class="form-group filter-b">\n' +
    '							<label class="select input-type">\n' +
    '								<select ng-change="onStateChange()" ng-options="s.Label disable when !s.Available for s in engineerStates" ng-model="filters.state"\n' +
    '								 class="form-control input-lg">\n' +
    '									<option value="">States (All)</option>\n' +
    '								</select>\n' +
    '							</label>\n' +
    '						</li>\n' +
    '					</ul>\n' +
    '				</form>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '		<!-- Cards -->\n' +
    '		<div id="cards" lazy-scroll="getMoreEngineers()" lazy-scroll-trigger="80">\n' +
    '			<div class="card" ng-repeat="engineer in engineers track by $index">\n' +
    '				<section class="user-profile">\n' +
    '					<ul class="list-inline mb20 clearfix">\n' +
    '						<li class="engineer-photo">\n' +
    '							<div ng-show="engineer.WorkHistoryCount != 0" class="badge" uib-tooltip="Work History" tooltip-popup-close-delay="2000">{{engineer.WorkHistoryCount}}</div>\n' +
    '							<a class="user-photo" style="background-image:url({{engineer.Picture.Url}}),url(assets/img/avatar.png);"></a>\n' +
    '						</li>\n' +
    '						<li class="user-info">\n' +
    '							<!-- Profile Info -->\n' +
    '							<h5>{{::engineer.Company}}</h5>\n' +
    '							<h4>\n' +
    '								<a href="" ui-sref="view-engineer({uid:engineer.Id})">{{::engineer.FullName}}</a>\n' +
    '								<small>{{::engineer.City}}, {{::engineer.State}}</small>\n' +
    '							</h4>\n' +
    '							<!-- Rating -->\n' +
    '							<div class="rating profile">\n' +
    '								<span class="review">{{engineer.ReviewCount}}</span>\n' +
    '								<span ng-repeat="i in [5, 4, 3, 2, 1]" ng-class="{\'on\': i <= engineer.AverageScore}"></span>\n' +
    '							</div>\n' +
    '						</li>\n' +
    '					</ul>\n' +
    '					<p>\n' +
    '						<div ng-repeat="license in engineer.groupedLicenses">\n' +
    '							<license-icon license={{license}} licenses={{licenses}}></license-icon>\n' +
    '						</div>\n' +
    '\n' +
    '						<div ng-repeat="license in engineer.groupedLicenses">\n' +
    '							<license-icon licenseId={{license.id}} licenses={{licenses}} licensesStates={{license.states}}></license-icon>\n' +
    '						</div>\n' +
    '					</p>\n' +
    '					<p class="user-bio" ng-if="engineer.Bio">\n' +
    '						{{::engineer.Bio | trimText:true:100:\' ...\'}}\n' +
    '					</p>\n' +
    '					<a ui-sref="view-engineer({uid:engineer.Id})" href="" class="btn btn-primary mt20">View</a>\n' +
    '				</section>\n' +
    '			</div>\n' +
    '			<!-- Load more -->\n' +
    '			<div class="load-cards" ng-show="loading">\n' +
    '				<a href="" class="fa fa-refresh fa-spin"></a>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '</section>');
}]);
